import isEmpty from "lodash/isEmpty";
import { DetailField } from "@/core/components/detail-field";
import { Button } from "@/core/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/core/components/ui/dialog";
import { Separator } from "@/core/components/ui/separator";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { getCustomerNameAndPhone } from "@/customer/utils";
import { IReferral } from "@/referrals/referral";

interface CloseConfirmationModalProps {
  referral: IReferral | null;
  onOpenChange: (referral: IReferral | null) => void;
  onConfirm: () => void;
}

export const CloseConfirmationModal = ({
  referral,
  onOpenChange,
  onConfirm,
}: CloseConfirmationModalProps) => {
  const { potential_customer, advocate, service_needed } = referral || {};

  const open = !isEmpty(referral);

  const handleOpenChange = (open: boolean) => {
    onOpenChange(open ? referral : null);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent description="Are you sure you want to mark this referral as lost? This action cannot be undone.">
        <DialogHeader>
          <DialogTitle>Mark as Lost</DialogTitle>
        </DialogHeader>

        <Stack className="p-6" gap="lg" fullWidth>
          <Typography variant="bodyW1" textColor="secondary">
            Are you sure you want to mark this referral as lost? This action
            cannot be undone.
          </Typography>
          <Stack direction="row" className="mx-auto">
            <DetailField
              label="Customer"
              message={getCustomerNameAndPhone(potential_customer)}
              fullWidth={false}
            />
            <Separator orientation="vertical" />
            <DetailField
              label="Advocate"
              message={getCustomerNameAndPhone(advocate)}
              fullWidth={false}
            />
            <Separator orientation="vertical" />
            <DetailField
              label="Service"
              message={service_needed || "No service"}
              fullWidth={false}
            />
          </Stack>
        </Stack>

        <DialogFooter>
          <Button
            variant="secondary"
            type="button"
            onClick={() => onOpenChange(null)}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              onConfirm();
              onOpenChange(null);
            }}
          >
            Mark as Lost
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
